/* import __COLOCATED_TEMPLATE__ from './specialties.hbs'; */
import Component from '@ember/component';
import classic from 'ember-classic-decorator';

@classic
export default class PracticeWebsiteEditMenuSpecialties extends Component {}
